import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-reward-summary-cards',
  templateUrl: './reward-summary-cards.component.html',
  styleUrls: ['./reward-summary-cards.component.scss']
})
export class RewardSummaryCardsComponent {
  @Input() redeemIncentives: boolean = false;
  @Input() redeemCredits: boolean = false;
  @Input() userPoints: any;
  @Input() pointsButton: boolean = true;
  @Input() cashEarnedData: any[] = [];
  @Input() userCredits: any;
  @Input() userProfile: any;
  @Input() disableRedeemTicket: boolean = false;
  @Input() ticketRedemptionData: any;

  @Output() redeemPointsClicked = new EventEmitter<void>();
  @Output() redeemTicketClicked = new EventEmitter<void>();
  @Output() backClicked = new EventEmitter<void>();
  @Output() ticketDetailsClicked = new EventEmitter<any>();

  splitData(value: any) {
    if (value) {
      const parseValue = parseFloat(value);
      const newData = parseValue.toLocaleString();
      return newData.toString();
    }
    return value;
  }
}
